import { useId } from 'react';

import type { IllustrationVariant } from './IllustrationBase';

const GLOW_PATH =
  'M197.27 70.0168C214.298 70.3792 232.877 75.0607 245.732 84.8523C246.7 85.5771 247.64 86.3397 248.553 87.1394C262.41 100 255.232 105.5 258.873 117C265.366 125.525 278.954 126.5 279.966 141.5C280.039 142.586 279.975 148.171 279.946 149.278C279.614 170.754 264.247 192.655 244.695 205.588C233.173 213.216 217.426 211.888 202.093 212C194.834 215.394 185.509 226.08 172.463 228.278C165.35 229.503 158.1 230.077 150.839 229.992C147.285 229.94 143.738 229.699 140.221 229.267C109.223 225.466 90.197 216.83 82.547 195C78.8541 187.929 81.6464 173.348 81.2301 171.5C67.1705 151.682 66.4477 137.542 78.3015 119.315C92.177 97.9574 117.679 98.637 135.783 97.5C145.451 88.6193 155.58 75.1997 175.042 71.789C182.346 70.4845 189.804 69.8897 197.27 70.0168Z';

const VERTICAL_AXIS = { x1: 175, y1: 206.203, x2: 172.075, y2: 99.0036 };
const DIAGONAL_AXIS = { x1: 145.798, y1: 177.956, x2: 201.317, y2: 113.587 };

interface IllustrationGlowProps {
  variant: IllustrationVariant;
}

export const IllustrationGlow = ({ variant }: IllustrationGlowProps) => {
  const id = useId();
  const blurId = `${id}-blur`;
  const fillId = `${id}-fill`;

  return (
    <>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="300"
          id={blurId}
          width="350"
          x="0"
          y="0"
        >
          <feGaussianBlur result="blur" stdDeviation="35" />
          <feTurbulence
            baseFrequency="1"
            numOctaves="2"
            stitchTiles="stitch"
            type="fractalNoise"
          />
          <feColorMatrix
            result="grain"
            values="1 0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0"
          />
          {/* blur × (0.85 + 0.3 × grain): jitters glow alpha ±15% so 8-bit dithering reads as texture */}
          <feComposite
            in="blur"
            in2="grain"
            k1="0.3"
            k2="0.85"
            operator="arithmetic"
          />
        </filter>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={fillId}
          {...(variant === 'warning' ? DIAGONAL_AXIS : VERTICAL_AXIS)}
        >
          <stop stopColor={`var(--illu-${variant}-glow-from)`} />
          <stop offset="1" stopColor={`var(--illu-${variant}-glow-to)`} />
        </linearGradient>
      </defs>
      <g
        filter={`url(#${blurId})`}
        style={{ opacity: `var(--illu-${variant}-glow-opacity)` }}
        transform="translate(-75 -50)"
      >
        <path d={GLOW_PATH} fill={`url(#${fillId})`} />
      </g>
    </>
  );
};
